import styled from "styled-components"

export const Card = styled.div`
  background-color: white;
  min-width: 285px;
  width: 25%;
  max-height: 600px;
  min-height: 550px;
  height: 65vh;
  display:flex;
  justify-content: center;
`;

export const ImgLogo = styled.img`
  width: 70%;
  height: 90%;
  display: flex;
  align-items: center;
`;
